export default "__VITE_ASSET__BZ3tBjA1__"